export default __webpack_public_path__ + "search-overview-header-1200-9874a2d315bca78e6088cdfe2cf6e698.png";